import { takeEvery, put, call } from "redux-saga/effects";
import {
  addPlacementToList,
  addPlacementToListFailure,
  addPlacementToListSuccess,
  deletePlacement,
  deletePlacementFailure,
  deletePlacementSuccess,
  editPlacement,
  editPlacementFailure,
  editPlacementSuccess,
  getNightPlacementList,
  setNightPlacementList
} from "../actions/nightPlacementListAction";
import { getNightPlacementListRequest } from "../../api/nightPlacementList/getNightPlacementListRequest";
import { message } from "antd";
import { addPlacementToListRequest } from "../../api/nightPlacementList/addPlacementToListRequest";
import { editPlacementRequest } from "../../api/nightPlacementList/editPlacementRequest";
import { deletePlacementRequest } from "../../api/nightPlacementList/deletePlacementRequest";

function* getNightPlacementListSaga(action) {
  try {
    const { orderId } = action.payload;
    const { pagination } = action.payload;
    const { sort } = action.payload;
    const response = yield call(
      getNightPlacementListRequest,
      orderId,
      pagination,
      sort
    );
    if (response.status === 200) {
      yield put(setNightPlacementList(response.data));
    }
  } catch (e) {
    console.log(e);
  }
}

function* addPlacementToListSaga(action) {
  try {
    const orderId = action.payload.orderId;
    const response = yield call(
      addPlacementToListRequest,
      orderId,
      action.payload
    );
    if (response.status === 201) {
      yield put(addPlacementToListSuccess());
      // В случае удачного добавления персоны - запрашиваем обновленный список персон
      const list = yield call(getNightPlacementListRequest, orderId);
      if (list.status === 200) {
        yield put(setNightPlacementList(list.data));
      }
    }
  } catch (e) {
    const { errors } = e && e.response && e.response.data;
    const errorMessage =
      e && e.response && e.response.data && e.response.data.message;
    message.error(errorMessage);
    yield put(addPlacementToListFailure({ message: errorMessage, errors }));
  }
}

function* editPlacementSaga(action) {
  try {
    const { orderId, placementId } = action.payload;
    const response = yield call(
      editPlacementRequest,
      orderId,
      placementId,
      action.payload
    );
    if (response.status === 200) {
      yield put(editPlacementSuccess());
      // В случае удачного добавления персоны - запрашиваем обновленный список персон
      const list = yield call(getNightPlacementListRequest, orderId);
      if (list.status === 200) {
        yield put(setNightPlacementList(list.data));
      }
    }
  } catch (e) {
    const { errors } = e && e.response && e.response.data;
    const errorMessage =
      e && e.response && e.response.data && e.response.data.message;
    message.error(errorMessage);
    yield put(editPlacementFailure({ message: errorMessage, errors }));
  }
}

function* deletePlacementSaga(action) {
  try {
    const { orderId, placementId } = action.payload;
    const response = yield call(deletePlacementRequest, orderId, placementId);
    if (response.status === 200) {
      yield put(deletePlacementSuccess());

      // В случае удачного удаления персоны - запрашиваем обновленный список персон
      const list = yield call(getNightPlacementListRequest, orderId);
      if (list.status === 200) {
        yield put(setNightPlacementList(list.data));
      }
    }
  } catch (e) {
    const { errors } = e && e.response && e.response.data;
    const errorMessage =
      e && e.response && e.response.data && e.response.data.message;
    message.error(errorMessage);
    yield put(deletePlacementFailure({ message: errorMessage, errors }));
  }
}

export function* nightPlacementListWatcher() {
  yield takeEvery(getNightPlacementList.toString(), getNightPlacementListSaga);
  yield takeEvery(addPlacementToList.toString(), addPlacementToListSaga);
  yield takeEvery(editPlacement.toString(), editPlacementSaga);
  yield takeEvery(deletePlacement.toString(), deletePlacementSaga);
}
